import React from 'react';
import AddOrEditVendorForm from './AddOrEditVendorForm';

/* React functional component */
const CreateVendorScreen = () => {
  return <AddOrEditVendorForm mode="add" />;
};

export default CreateVendorScreen;
